<template>
	<div class="row contentblock" data-aos="fade-in" data-aos-duration="1500" data-aos-once="true">
		<div class="columns column6">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	padding: 0;
	background: var(--primary-background-color);

	&:nth-child(odd) {
		flex-direction: row-reverse;
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.contentblock-content {
		padding: 70px 50px;
	}
}

@media (max-width: 1080px) {
	.contentblock .column6 {
		width: 100%;
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding-left: 20px;
			padding-right: 20px;
		}
	}
}
</style>
